import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './HomePage';
import QuizPageWrapper from './QuizPageWrapper';
import Pensum from './Pensum';
import WordsQuiz from './WordsQuiz';
import KataWrapper from './KataWrapper'
import WordSearch from './WordSearch';
import WrittenQuiz from './WrittenQuiz';
import Judolingo from './Judolingo';
import UserLogin from './UserLogin';
import UserProfile from './UserProfile';

function App() {
  useEffect(() => {
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/pensum" element={<Pensum />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/quiz" element={<QuizPageWrapper />} />
        <Route path="/Words" element={<WordsQuiz />} />
        <Route path="/Kata" element={<KataWrapper />} />
        <Route path="/WordSearch" element={<WordSearch />} />
        <Route path="/WrittenQuiz" element={<WrittenQuiz />} />
        <Route path="/Judolingo" element={<Judolingo />} />
        <Route path="/login" element={<UserLogin />} />
        <Route path="/profile" element={<UserProfile />} />
      </Routes>
    </Router>
  );
}

export default App;
